import { useCallback, useState } from "react";

export function useReplay(setHit) {
  const [primed, setPrimed] = useState(false);
  const replay = useCallback(() => {
    setPrimed(true);
    setTimeout(() => {
      setPrimed(false);
      setHit((h) => h && { ...h, id: Date.now() });
    }, 90);
  }, [setHit]);
  return { primed, replay };
}
